import React, { useEffect, useRef, useCallback } from 'react';
import { useMap, Marker as LMarker } from 'react-leaflet';
import L from 'leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import 'react-leaflet-markercluster/styles';

// Component to display traffic markers for strade and varchi
function TrafficMarkers({ stradeData, varchiData, onMarkerClick, selectedMarkers = [] }) {
  const map = useMap();
  const polylinesRef = useRef([]);
  const currentHighlightedStreet = useRef(null);
  const currentOpenPopup = useRef(null);

  // Create custom tooltip content with button
  const createTooltipContent = useCallback((type, data, id) => {
    if (type === 'strada' && stradeData) {
      const timeseries = stradeData.timeseriesByDirection[id];
      const latestData = timeseries && timeseries.length > 0 ? timeseries[timeseries.length - 1] : null;

      return `
        <div style="padding: 10px; min-width: 200px; background: white; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.15);">
          <h4 style="margin: 0 0 8px 0; font-size: 14px; color: #333; font-weight: 600;">
            ${data.street_direction}
          </h4>
          ${latestData ? `
            <div style="margin-bottom: 8px; padding: 8px; background: #f5f5f5; border-radius: 4px;">
              <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
                <span style="color: #666; font-size: 12px;">Velocità attuale:</span>
                <span style="color: #333; font-size: 12px; font-weight: 500;">${Math.round(latestData.Actual)} Secondi</span>
              </div>
              <div style="display: flex; justify-content: space-between;">
                <span style="color: #666; font-size: 12px;">Previsione 15min:</span>
                <span style="color: #1890ff; font-size: 12px; font-weight: 500;">${Math.round(latestData.Pred15min)} Secondi</span>
              </div>
            </div>
          ` : '<p style="color: #999; font-size: 12px; margin: 8px 0;">Nessun dato disponibile</p>'}
          <div style="display: flex; gap: 8px; flex-direction: column;">
            <button
              onclick="window.dispatchEvent(new CustomEvent('showTrafficChart', { detail: { type: 'strada', id: '${id}' }}))"
              style="
                width: 100%;
                padding: 8px;
                background: #1890ff;
                color: white;
                border: none;
                border-radius: 6px;
                cursor: pointer;
                font-size: 13px;
                font-weight: 500;
                transition: background 0.3s;
              "
              onmouseover="this.style.background='#40a9ff'"
              onmouseout="this.style.background='#1890ff'"
            >
              Visualizza Grafico
            </button>
            <button
              onclick="window.dispatchEvent(new CustomEvent('addToConfronto', { detail: { type: 'brain_strada', id: '${id}', name: '${data.street_direction}' }}))"
              style="
                width: 100%;
                padding: 8px;
                background: #52c41a;
                color: white;
                border: none;
                border-radius: 6px;
                cursor: pointer;
                font-size: 13px;
                font-weight: 500;
                transition: background 0.3s;
              "
              onmouseover="this.style.background='#73d13d'"
              onmouseout="this.style.background='#52c41a'"
            >
              + Confronto
            </button>
          </div>
        </div>
      `;
    } else if (type === 'varco' && varchiData) {
      const timeseries = varchiData.timeseriesByKey[id];
      const latestData = timeseries && timeseries.length > 0 ? timeseries[0] : null;

      return `
        <div style="padding: 10px; min-width: 200px; background: white; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.15);">
          <h4 style="margin: 0 0 8px 0; font-size: 14px; color: #333; font-weight: 600;">
            ${data.gate}
          </h4>
          <div style="margin-bottom: 8px;">
            <span style="
              display: inline-block;
              padding: 2px 8px;
              background: ${data.direction === 'IN' ? '#f6ffed' : '#fff1f0'};
              color: ${data.direction === 'IN' ? '#52c41a' : '#f5222d'};
              border: 1px solid ${data.direction === 'IN' ? '#b7eb8f' : '#ffa39e'};
              border-radius: 4px;
              font-size: 12px;
              font-weight: 500;
            ">
              ${data.direction === 'IN' ? '→ Ingresso' : '← Uscita'}
            </span>
          </div>
          ${latestData ? `
            <div style="margin-bottom: 8px; padding: 8px; background: #f5f5f5; border-radius: 4px;">
              <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
                <span style="color: #666; font-size: 12px;">Veicoli/ora:</span>
                <span style="color: #333; font-size: 12px; font-weight: 500;">${Math.round(latestData.Actual)}</span>
              </div>
              <div style="display: flex; justify-content: space-between;">
                <span style="color: #666; font-size: 12px;">Tipo:</span>
                <span style="color: #333; font-size: 12px; font-weight: 500;">${latestData.vehicle || 'Auto'}</span>
              </div>
            </div>
          ` : '<p style="color: #999; font-size: 12px; margin: 8px 0;">Nessun dato disponibile</p>'}
          <div style="display: flex; gap: 8px; flex-direction: column;">
            <button
              onclick="window.dispatchEvent(new CustomEvent('showTrafficChart', { detail: { type: 'varco', id: '${id}' }}))"
              style="
                width: 100%;
                padding: 8px;
                background: #1890ff;
                color: white;
                border: none;
                border-radius: 6px;
                cursor: pointer;
                font-size: 13px;
                font-weight: 500;
                transition: background 0.3s;
              "
              onmouseover="this.style.background='#40a9ff'"
              onmouseout="this.style.background='#1890ff'"
            >
              Visualizza Grafico
            </button>
            <button
              onclick="window.dispatchEvent(new CustomEvent('addToConfronto', { detail: { type: 'brain_varco', id: '${id}', name: '${data.marker_key || data.gate}' }}))"
              style="
                width: 100%;
                padding: 8px;
                background: #52c41a;
                color: white;
                border: none;
                border-radius: 6px;
                cursor: pointer;
                font-size: 13px;
                font-weight: 500;
                transition: background 0.3s;
              "
              onmouseover="this.style.background='#73d13d'"
              onmouseout="this.style.background='#52c41a'"
            >
              + Confronto
            </button>
          </div>
        </div>
      `;
    }
    return '';
  }, [stradeData, varchiData]);

  useEffect(() => {
    // Clear existing polylines
    polylinesRef.current.forEach(polyline => {
      if (polyline && polyline.remove) {
        polyline.remove();
      }
    });
    polylinesRef.current = [];

    if (!map) return;

    // Function to highlight street polylines on hover
    const highlightStreetPolylines = (streetDirection, highlight = true) => {
      // Clear any previous highlights first
      if (currentHighlightedStreet.current && currentHighlightedStreet.current !== streetDirection) {
        polylinesRef.current.forEach(polyline => {
          if (polyline._streetDirection === currentHighlightedStreet.current &&
            !selectedMarkers.includes(currentHighlightedStreet.current)) {
            polyline.setStyle({
              color: '#ccc',  // Return to default gray
              weight: 2,
              opacity: 0.5
            });
          }
        });
      }

      polylinesRef.current.forEach(polyline => {
        if (polyline._streetDirection === streetDirection) {
          const isMarkerSelected = selectedMarkers.includes(streetDirection);

          if (isMarkerSelected && highlight) {
            // Hovering over a visible polyline - make it brighter
            polyline.setStyle({
              color: '#40a9ff',  // Lighter blue for hover effect
              weight: 7,
              opacity: 1
            });
            polyline.bringToFront();
            currentHighlightedStreet.current = streetDirection;
          } else if (isMarkerSelected && !highlight) {
            // Not hovering but marker is selected - show normal blue
            polyline.setStyle({
              color: '#1890ff',
              weight: 6,
              opacity: 1
            });
            if (currentHighlightedStreet.current === streetDirection) {
              currentHighlightedStreet.current = null;
            }
          } else {
            // Marker not selected - hide the polyline
            polyline.setStyle({
              color: 'transparent',
              weight: 2,
              opacity: 0
            });
            if (currentHighlightedStreet.current === streetDirection) {
              currentHighlightedStreet.current = null;
            }
          }
        }
      });
    };

    // Add polylines for strade
    if (stradeData && stradeData.geo) {
      stradeData.geo.forEach(street => {
        const { street_direction, polylines_lonlat } = street;

        // Draw polylines for the street segments
        if (polylines_lonlat && Array.isArray(polylines_lonlat)) {
          polylines_lonlat.forEach((polyline, index) => {
            if (Array.isArray(polyline) && polyline.length > 0) {
              // Convert lon,lat to lat,lon for Leaflet
              const latlngs = polyline.map(coord => [coord[1], coord[0]]);

              const isSelected = selectedMarkers.includes(street_direction);

              const polylineLayer = L.polyline(latlngs, {
                color: isSelected ? '#1890ff' : 'transparent',  // Blue when selected, invisible otherwise
                weight: isSelected ? 6 : 2,
                opacity: isSelected ? 1 : 0,  // Fully transparent when not selected
                className: `street-polyline street-${street_direction.replace(/\s+/g, '-')}`,
                smoothFactor: 1,
                interactive: isSelected  // Only interactive when selected
              }).addTo(map);

              // Store reference to street direction for highlighting
              polylineLayer._streetDirection = street_direction;

              // Only add interaction handlers if this polyline is currently selected
              if (isSelected) {
                // Add click handler to polyline to select the road from main network
                polylineLayer.on('click', function (e) {
                  // Stop event propagation to prevent marker click
                  L.DomEvent.stopPropagation(e);

                  // Extract street name without direction suffix
                  const streetName = street_direction.replace(' pos', '').replace(' neg', '').trim();

                  // Call the handler that selects from the main network
                  // This will select the road and show it in purple (network selection)
                  if (window.selectRoadFromNetwork) {
                    window.selectRoadFromNetwork(streetName);
                  }
                });

                // Add hover handlers to polyline for highlighting (only when selected)
                polylineLayer.on('mouseover', function (e) {
                  highlightStreetPolylines(street_direction, true);
                });

                polylineLayer.on('mouseout', function (e) {
                  highlightStreetPolylines(street_direction, false);
                });
              }

              polylinesRef.current.push(polylineLayer);
            }
          });
        }
      });
    }

    // Listen for custom chart show events
    const handleShowChart = (event) => {
      if (onMarkerClick && event.detail) {
        onMarkerClick(event.detail.type, event.detail.id);
        // Close any open popups
        map.closePopup();
      }
    };

    window.addEventListener('showTrafficChart', handleShowChart);

    // Cleanup
    return () => {
      window.removeEventListener('showTrafficChart', handleShowChart);
      polylinesRef.current.forEach(polyline => {
        if (polyline && polyline.remove) {
          polyline.remove();
        }
      });
      polylinesRef.current = [];
    };
  }, [stradeData, selectedMarkers, map, onMarkerClick]);

  // Prepare marker data for clustering
  const markerElements = [];

  // Create custom icons with smaller size
  const stradeIcon = L.icon({
    iconUrl: '/data/strade/strade.png',
    iconSize: [24, 24],
    iconAnchor: [12, 12],
    popupAnchor: [0, -12]
  });

  const varchiIcon = L.icon({
    iconUrl: '/data/varchi/varchi.png',
    iconSize: [24, 24],
    iconAnchor: [12, 12],
    popupAnchor: [0, -12]
  });

  // Add strade markers
  if (stradeData && stradeData.geo) {
    stradeData.geo.forEach(street => {
      const { marker_lat, marker_lon, street_direction } = street;

      markerElements.push(
        <LMarker
          key={`strada-${street_direction}`}
          position={[marker_lat, marker_lon]}
          icon={stradeIcon}
          eventHandlers={{
            click: () => {
              // Extract street name without direction suffix for matching
              const streetName = street.street_direction.replace(' pos', '').replace(' neg', '').trim();

              // Call onMarkerClick to toggle traffic marker selection for polyline highlighting
              // Pass streetName to indicate this is a marker click (not button click)
              if (onMarkerClick) {
                onMarkerClick('strada', street_direction, streetName);
              }

              // Close any existing popups first
              map.closePopup();

              // Show popup for this marker
              const popup = L.popup({
                maxWidth: 300,
                className: 'traffic-tooltip-popup'
              })
                .setLatLng([marker_lat, marker_lon])
                .setContent(createTooltipContent('strada', street, street_direction))
                .openOn(map);

              // When popup closes, deselect the traffic marker to remove blue highlight
              popup.on('remove', () => {
                // Directly update selectedTrafficMarkers instead of calling onMarkerClick
                // This prevents double-toggling and ensures clean deselection
                if (window.deselectTrafficMarker) {
                  window.deselectTrafficMarker(street_direction);
                }
              });

              // Track the current open popup
              currentOpenPopup.current = street_direction;
            }
          }}
        />
      );
    });
  }

  // Add varchi markers
  if (varchiData && varchiData.geo) {
    varchiData.geo.forEach(varco => {
      const { marker_lat, marker_lon, marker_key, gate, direction } = varco;

      markerElements.push(
        <LMarker
          key={`varco-${marker_key}`}
          position={[marker_lat, marker_lon]}
          icon={varchiIcon}
          eventHandlers={{
            click: () => {
              // Close any existing popups first
              map.closePopup();

              // Show popup for this marker
              L.popup({
                maxWidth: 300,
                className: 'traffic-tooltip-popup'
              })
                .setLatLng([marker_lat, marker_lon])
                .setContent(createTooltipContent('varco', varco, marker_key))
                .openOn(map);
            }
          }}
        />
      );
    });
  }

  return (
    <MarkerClusterGroup
      chunkedLoading
      iconCreateFunction={(cluster) => {
        const childCount = cluster.getChildCount();
        let c = ' marker-cluster-';
        if (childCount < 10) {
          c += 'small';
        } else if (childCount < 100) {
          c += 'medium';
        } else {
          c += 'large';
        }
        return new L.DivIcon({
          html: '<div><span>' + childCount + '</span></div>',
          className: 'marker-cluster' + c,
          iconSize: new L.Point(40, 40)
        });
      }}
    >
      {markerElements}
    </MarkerClusterGroup>
  );
}

export default TrafficMarkers;